import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";


import {UiBaseComponent} from "../ui-base.component";

@Component({
    selector: 'qnect-ui-radio-button',
    templateUrl: './ui-radio-button.component.html',
    styleUrls: ['./ui-radio-button.component.scss', '../ui-base.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UiRadioButtonComponent extends UiBaseComponent implements OnInit {

  selectedText: string;

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.setSelectedText();
    this.formControl.valueChanges.subscribe(data => {
      this.setSelectedText();
    });
  }

  setSelectedText() {
    this.uiModel.options.forEach(each => {
    if (this.formControl.value === each.value) {
        this.selectedText = each.label;
        // break loop
        return false;
      }
    });
  }

  getSelectedRadioText() {
    return this.selectedText;
  }

  toggle(option) {
    this.formControl.setValue(option.value);
    this.formControl.markAsTouched();
    this.formControl.markAsDirty();
  }

}
